module.exports = __webpack_public_path__ + "img/cloud.bcae86e0.png";